import RouteWrapper from "../shared/routing/RouteWrapper";
import {Redirect, Switch} from "react-router-dom";
import routes from "../shared/routing/routes";
import {ROUTE_PATH} from "../shared/utils/constants";

const App = () => {
    return (
        <Switch>
            {routes.map((r) => (
                    <RouteWrapper key={r.path}
                                  path={r.path}
                                  exact
                                  component={r.component}
                                  layout={r.layout}/>
                ))}
            <Redirect to={ROUTE_PATH.companiesManagement}/>
        </Switch>
    );
}

export default App;
